import { render, staticRenderFns } from "./CheckerboardButtonNav.vue?vue&type=template&id=65a3de8c"
import script from "./CheckerboardButtonNav.vue?vue&type=script&lang=js"
export * from "./CheckerboardButtonNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports